
import { LocalStorage } from '@/src/utils/general/local-storage';
import { StoreApi, UseBoundStore, create } from 'zustand';
import { GeneralStore, createGeneralStore } from './general';
import { PlacementsStore, createPlacementsStore } from './placements';
import { TagsStore, createTagsStore } from './tags';
import { TagsManagerActions } from './tags/actions';
import { UserStore, createUserStore } from './user';

export let useClicksterStore: UseBoundStore<
  StoreApi<
    GeneralStore &
    UserStore &
    PlacementsStore &
    TagsStore
  >
>;

export const createClicksterStore = () => {
  const store = create<GeneralStore & UserStore & PlacementsStore & TagsStore>()((...a) => ({
    ...createGeneralStore(...a),
    ...createUserStore(...a),
    ...createPlacementsStore(...a),
    ...createTagsStore(...a),
  }));

  store.subscribe((state, prevState) => {
    const { tags, tagsGroups, tagsById } = state;
    const { tags: prevTags } = prevState;

    LocalStorage.set('tag-manager', { tags, tagsGroups, tagsById });
    TagsManagerActions.tags.tagStoreSubscribe(tags, prevTags);
  });

  useClicksterStore = store;
};
